import React from 'react';
import { IntlProvider, MessageFormatElement } from 'react-intl';
import { NextPage } from 'next';
import NextHead from 'next/head';
import { TranslationProvider } from 'providers/TranslationProvider';
import { useT } from '@transifex/react';
import { Layout, LayoutProps, NoSsr, RemountOnBfCachedLoad } from '@raisin/cp-layout';
import { Locale } from '@raisin/cp-utils';
import { LoginComponent } from 'components/LoginComponent';
import { mapLocaleToDomain } from 'utils/helpers';

export { getRetailMinimalStaticProps as getStaticProps } from 'utils/nextPage';

interface HomeProps {
  messages: Record<string, string> | Record<string, MessageFormatElement[]>;
  layout: LayoutProps['layout'];
  locale: Locale;
}

const Content = ({ locale }: { locale: Locale }) => {
  const t = useT();

  return (
    <>
      <NextHead>
        <title>{t('login.page.title')}</title>
        <link rel="canonical" href={`${mapLocaleToDomain(locale)}/login/`} />
      </NextHead>
      {/* remount LoginComponent to reset its state (needed after OTP and resetting captcha) after a load by BfCache */}
      <RemountOnBfCachedLoad>
        {/* disabling SSR workaround to prevent https://github.com/mui/material-ui/issues/29742 */}
        <NoSsr>
          <LoginComponent locale={locale} />
        </NoSsr>
      </RemountOnBfCachedLoad>
    </>
  );
};

const Home: NextPage<HomeProps> = ({ messages, layout, locale }) => (
  <IntlProvider messages={messages} locale={locale}>
    <TranslationProvider locale={locale}>
      <Layout
        layout={layout}
        isLogin
        isAuthRequired={false}
        isSmartBannerPage
        pageMessages={messages}
      >
        <Content locale={locale} />
      </Layout>
    </TranslationProvider>
  </IntlProvider>
);

export default Home;
